import { render } from "./ModalRememberOne.vue?vue&type=template&id=4e0ef55a&scoped=true&ts=true"
import script from "./ModalRememberOne.vue?vue&type=script&lang=ts"
export * from "./ModalRememberOne.vue?vue&type=script&lang=ts"

import "./ModalRememberOne.vue?vue&type=style&index=0&id=4e0ef55a&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0ef55a"]])

export default __exports__